module.exports = __webpack_public_path__ + "img/specialiste_com._hotel_M.M_051.6c7837b6.jpg";